module.exports = __webpack_public_path__ + "static/media/10.a97f074c.mp3";